<template>
<component
  v-if="icon"
  :is="icon"
  :size="size"
  :color="color"
  :stroke-width="strokeWidth"
  :class="defaultClass"
/>
</template>

<script setup>
import { computed } from 'vue'
import * as icons from 'lucide-vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  size: {
    type: Number,
    default: 24
  },
  color: {
    type: String,
    default: 'currentColor'
  },
  strokeWidth: {
    type: Number,
    default: 2
  },
  defaultClass: {
    type: String,
    default: ''
  }
})
const icon = computed(() => icons[props.name])
</script>

